<template>
  <form-section
    v-if="showTermsAndConditions"
    no-validity
  >
    <lg-terms-and-conditions />
  </form-section>
</template>

<script>
import LgTermsAndConditions from '@/views/LG/components/LgTermsAndConditions.vue';

export default {
  name: 'terms-and-conditions-lg',
  components: {
    LgTermsAndConditions,
  },
  inject: ['isLeadgen'],
  computed: {
    showTermsAndConditions () {
      return this.isLeadgen;
    },
  },
};
</script>
